import React from 'react';
import classNames from 'classnames';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import { FormattedMessage } from 'react-intl';

interface CM4RequestLogButtonProps {
    disabled?: boolean;
    isUserAllowed: boolean;
}

const CM4RequestLogButton: React.FC<CM4RequestLogButtonProps> = ({
    disabled,
    isUserAllowed,
}) => {
    const button = (
        <button
            form={'cm4-log-form'}
            type='submit'
            disabled={disabled || !isUserAllowed}
            className={classNames('btn btn-primary', { disabled: !isUserAllowed })}
        >
            <FormattedMessage id='intl-msg:logs:createLogRequestButton'/>
        </button>
    );

    if (disabled) {
        return (
            <OverlayTrigger
                placement='top'
                overlay={
                    <Tooltip id='tooltip'>
                        <FormattedMessage
                            id='intl-msg:logs:logRequestsUnavailableOffline'
                            defaultMessage='Log requests are not available on offline devices'
                        />
                    </Tooltip>
                }
            >
                {button}
            </OverlayTrigger>
        );
    }

    return button;
};

export default CM4RequestLogButton;
